/** Single stack for this feature — JetBrains Mono only (plus generic monospace fallback).
 *  The font itself is self-hosted globally via @fontsource (see src/index.js). */
export const artistsGalleryFontFamily = '"JetBrains Mono", monospace';
